import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import History from './pages/History';
import Dashboard from './pages/Dashboard';
import ViralClipsMetadataPage from './pages/ViralClipsMetadataPage';
import EnhancedClipsMetadataPage from './pages/EnhancedClipsMetadataPage';
import ViralClipsDashboardDemo from './pages/ViralClipsDashboardDemo';
import LoadingOverlay from './components/LoadingOverlay';
import CreditManagement from './pages/CreditManagement';
import './App.css';

function App() {
  const isLoading = useSelector(state => state.cms.isLoading);

  return (
    <Router>
      <div className="app">
        {isLoading && <LoadingOverlay />}
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/viral-clips-metadata" element={<ViralClipsMetadataPage />} />
            <Route path="/viral-clips-metadata/:jobId" element={<ViralClipsMetadataPage />} />
            <Route path="/enhanced-clips/:videoId" element={<EnhancedClipsMetadataPage />} />
            <Route path="/enhanced-clips/:videoId/:chunkId" element={<EnhancedClipsMetadataPage />} />
            <Route path="/viral-clips-dashboard" element={<ViralClipsDashboardDemo />} />
            <Route path="/viral-clips-dashboard/:jobId" element={<ViralClipsDashboardDemo />} />
            <Route path="/history" element={<History />} />
            <Route path="/credit-management" element={<CreditManagement />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
